import PropTypes from 'prop-types';
import { useFilePicker } from "use-file-picker";
import { Button } from "../Button/Button";
import { Icon } from "../Icon/Icon";
import { Link } from "../Link/Link";
import { downloader } from "../../common/Downloader/Downloader";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = ".kof-file-picker ul.files {\n  margin-top: 4px;\n  margin-bottom: 0;\n  padding-left: 0;\n  list-style: none;\n}\n.kof-file-picker ul.files li {\n  display: flex;\n  align-items: center;\n}\n.kof-file-picker ul.files li svg {\n  margin-right: 8px;\n}\n.kof-file-picker ul.files li svg:hover {\n  cursor: pointer;\n}";
  const fileName = "FilePicker_FilePicker_99ac6634-d26e-4562-a8ad-915b45fc590d";
  const element = document.querySelector("style[data-sass-component='FilePicker_FilePicker_99ac6634-d26e-4562-a8ad-915b45fc590d']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function FilePicker(props) {
  const [openFileSelector] = useFilePicker({
    accept: props.fileEndings,
    multiple: Boolean(props.multiple),
    readAs: 'DataURL',
    onFilesSelected: data => {
      const pickerFiles = data.filesContent;
      const newFiles = pickerFiles.map(pickerFile => {
        const base64 = extractBase64FromDataUrl(pickerFile.content);
        return {
          data: base64,
          name: pickerFile.name
        };
      });
      props.onChange(newFiles);
    }
  });
  const extractBase64FromDataUrl = dataURI => {
    const indexIdentifier = 'base64,';
    const offset = dataURI.indexOf(indexIdentifier) + indexIdentifier.length;
    return dataURI.substring(offset);
  };
  const remove = file => props.onChange(props.files.filter(filteringFile => filteringFile.name !== file.name));
  return /*#__PURE__*/_jsxs("div", {
    className: 'kof-file-picker',
    children: [/*#__PURE__*/_jsx(Button, {
      onClick: openFileSelector,
      type: "secondary",
      children: props.label
    }), Boolean(props.files.length) && /*#__PURE__*/_jsx("ul", {
      className: 'files',
      children: props.files.map(file => /*#__PURE__*/_jsxs("li", {
        children: [/*#__PURE__*/_jsx(Icon, {
          type: 'remove-x',
          onClick: () => remove(file)
        }), /*#__PURE__*/_jsx(Link, {
          target: () => downloader.download(file.data, file.name),
          children: file.name
        })]
      }, file.name))
    })]
  });
}
FilePicker.propTypes = {
  label: PropTypes.string.isRequired,
  fileEndings: PropTypes.array.isRequired,
  files: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    data: PropTypes.string.isRequired
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  multiple: PropTypes.bool
};
export { FilePicker };